export const Typography = {
  fontFamily: "Rubik",
  htmlFontSize: 10,
  fontSize: 14,

  body1: {
    fontSize: 14,
    fontWeight: 400,
  },
  body2: {
    fontSize: 12,
    fontWeight: 400,
  },
  subtitle1: {
    fontSize: 18,
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: 16,
    fontWeight: 400,
  },
  h1: {
    fontSize: 35,
    fontWeight: 700,
  },
  h2: {
    fontSize: 29,
    fontWeight: 700,
  },
  h3: {
    fontSize: 22,
    fontWeight: 700,
  },
  h4: {
    fontSize: 20,
    fontWeight: 700,
  },
  h5: {
    fontSize: 18,
    fontWeight: 700,
  },
  h6: {
    fontSize: 14,
    fontWeight: 700,
  },
};
